<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form @submit.native.prevent :model="queryParams" ref="queryForm" size="small" :inline="true" label-width="68px">
      <el-form-item label="查询条件" prop="keyword">
        <el-input v-model="queryParams.keyword" placeholder="请输入站点或者省份" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
      </el-form-item>
      <el-form-item>
        {{timeFormat}}
      </el-form-item>
      <el-form-item>
        共<span style="color: #00c853">{{count}}</span>站
      </el-form-item>
    </el-form>
    <el-table ref="tables" v-loading="loading" :data="list"  highlight-current-row>
      <el-table-column label="排名" type="index" width="50"/>
      <el-table-column label="所属省份" align="center" prop="province"  />
      <el-table-column label="站点名称" align="center" prop="name" />
      <el-table-column label="站点编号" align="center" prop="code"  />
      <el-table-column label="温度" align="center" prop="value"  >
        <template slot-scope="scope">
          {{scope.row.value}}℃
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { listTemperature} from "@/api/tool/temperature";

export default {
  name: "Temperature",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 列表数据
      list:[],
      allList: [],
      count:0,
      // 弹出层标题
      title: "",
      timeFormat: "",
      // 查询参数
      queryParams: {
        keyword: null
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询温度列表 */
    getList() {
      listTemperature().then(response => {
        this.allList = response.data.stations;
        this.list = this.sortBykey(response.data.stations,'value')
        this.timeFormat = response.data.formatTime
        this.count = response.data.stations.length
        this.loading = false
      });
    },
    handleQuery(){
      this.loading = true
      if(this.queryParams.keyword!=null){
        this.list=this.allList.filter((item)=>{ return item.name.indexOf(this.queryParams.keyword) !== -1 || item.province.indexOf(this.queryParams.keyword) !== -1})
      }else{
        this.list = this.allList
      }
      this.sortBykey(this.list,'value')
      this.count = this.list.length
      this.loading = false
    },
    sortBykey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key]
        var y = b[key]
        return y-x
      })
    },
  }
}

</script>
